"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceGeneratorControls = class UcInvoiceGeneratorControls extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "InvoiceGeneratorPanel.formData");
        this.$$cache_filters = new core_1.ComponentValueCache(this, "filters", "InvoiceGeneratorPanel.filters");
        this.$$cache_includeWorksheets = new core_1.ComponentValueCache(this, "includeWorksheets", "InvoiceGeneratorPanel.includeWorksheets");
        this.$$cache_invoiceGroupFilters = new core_1.ComponentValueCache(this, "invoiceGroupFilters", "InvoiceGeneratorPanel.invoiceGroupFilters");
        this.$$cache_taskStatusDismissed = new core_1.ComponentValueCache(this, "taskStatusDismissed", "InvoiceGeneratorPanel.taskStatusDismissed");
    }
    beforeDestroy(...args) {
        this.poller.stop();
    }
    onPoll(...args) {
        console.log("Poll completed!");
    }
    getPayload(...args) {
        {
            {
                return {
                    ...this.item,
                    ..._.reduce(this.filters, (m, filter) => {
                        const target = (filter.op === 'include' ? '' : 'exclude_') + filter.type;
                        const arr = _.get(m, target, []);
                        arr.push(filter.id);
                        m[target] = arr;
                        return m;
                    }, {}),
                    product_invoice_groups: _.reduce(this.invoiceGroupFilters, (arr, v, k) => {
                        if (!!v) {
                            arr.push(k);
                        }
                        return arr;
                    }, []),
                    exclude_product_invoice_groups: _.reduce(this.invoiceGroupFilters, (arr, v, k) => {
                        if (!v) {
                            arr.push(k);
                        }
                        return arr;
                    }, []),
                    skip_worksheets: !this.includeWorksheets
                };
            }
        }
    }
    updateStatus(...args) {
        _.extend(this.currentGeneratorTask, args[0]);
    }
    labelAlign;
    currentGeneratorTask;
    async $$load_currentGeneratorTask() {
        return this.$fn.fetch('read_invoice_generation_task', { parameters: { id: 'current' } });
    }
    poller;
    async $$load_poller() {
        return this.$fn.poller({ callback: () => this.onPoll(), id: "InvoiceGenerator" });
    }
    item;
    async $$load_item() {
        return {
            description: 'Invoice generation job',
            fulfillment_date: this.$fn.today(),
            due_date: null,
            billing_period_start: this.$fn.today(),
            billing_period_end: null,
            exchange_rates: [],
            service_type_flat_rate: true,
            service_type_measured: true,
            ignore_meter_billing_thresholds: false,
            meter_readings_start_date: null,
            invoice_tags: [],
            include_zero_consumptions: true,
            exclude_past_periods: true
        };
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    groups;
    async $$load_groups() {
        return this.$fn.fetch('list_group').then(p => p.data);
    }
    productInvoiceGroups;
    async $$load_productInvoiceGroups() {
        return this.$fn.fetch('list_product_invoice_group');
    }
    contractTypes;
    async $$load_contractTypes() {
        return _.map(this.$fn.getEnumValuesFromSchema('ContractTypes'), p => ({ id: p.value, name: p.text }));
    }
    filterOptionTemplates;
    filterTypes;
    async $$load_filterTypes() {
        return [
            {
                text: this.$fn.gettext('Companies'),
                target: 'companies',
                dataSource: {
                    name: 'suggest_company',
                    parameters: {
                        role: 'own',
                        with_contracts: true
                    }
                },
                useOptionTemplateForSelectedOption: true,
                optionTemplate: '<UcSuggestCompanyOption :option="option"></UcSuggestCompanyOption>',
            },
            {
                text: this.$fn.gettext('Clients'),
                target: 'tenants',
                dataSource: {
                    name: 'suggest_company',
                    parameters: {
                        role: 'partner',
                        with_contracts: true
                    }
                },
                useOptionTemplateForSelectedOption: true,
                optionTemplate: '<UcSuggestCompanyOption :option="option"></UcSuggestCompanyOption>',
            },
            {
                text: this.$fn.gettext('Client Groups'),
                target: 'client_groups',
                options: _.filter(this.groups, { group_type: 'company' })
            },
            {
                text: this.$fn.gettext('Contracts'),
                target: 'contracts',
                dataSource: {
                    name: 'suggest_contract',
                    parameters: {}
                },
                useOptionTemplateForSelectedOption: true,
                optionTemplate: '<UcSuggestContractOption :option="option"></UcSuggestContractOption>',
            },
            {
                text: this.$fn.gettext('Rentals'),
                target: 'rentals',
                dataSource: {
                    name: 'suggest_rental',
                    parameters: {}
                },
                useOptionTemplateForSelectedOption: true,
                optionTemplate: '<UcSuggestRentalOption :option="option"></UcSuggestRentalOption>',
            },
            {
                text: this.$fn.gettext('Meter Groups'),
                target: 'meter_groups',
                options: _.filter(this.groups, { group_type: 'meter' })
            },
            {
                text: this.$fn.gettext('Contract types'),
                target: 'contract_types',
                options: this.contractTypes,
            },
        ];
    }
    selectedFilterType;
    selectedFilterValue;
    selectedOperation;
    filters;
    async $$load_filters() {
        return [];
    }
    includeWorksheets;
    invoiceGroupFilters;
    async $$load_invoiceGroupFilters() {
        return _.chain(this.productInvoiceGroups)
            .reduce((m, p) => (m[p.id] = true, m), {})
            .value();
    }
    operations;
    taskStatusDismissed;
    ux;
    b_5733683578645513_clearable;
    dataMembers = ['labelAlign', 'currentGeneratorTask', 'poller', 'item', 'formId', 'groups', 'productInvoiceGroups', 'contractTypes', 'filterOptionTemplates', 'filterTypes', 'selectedFilterType', 'selectedFilterValue', 'selectedOperation', 'filters', 'includeWorksheets', 'invoiceGroupFilters', 'operations', 'taskStatusDismissed', 'ux', 'b_5733683578645513_clearable'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: null,
                currentGeneratorTask: null,
                poller: null,
                item: null,
                formId: null,
                groups: null,
                productInvoiceGroups: null,
                contractTypes: null,
                filterOptionTemplates: {
                    client: "UcSuggestCompanyOption",
                    contract: "UcSuggestContractOption",
                    rental: "UcSuggestRentalOption",
                },
                filterTypes: null,
                selectedFilterType: null,
                selectedFilterValue: null,
                selectedOperation: "include",
                filters: null,
                includeWorksheets: true,
                invoiceGroupFilters: null,
                operations: [{
                        value: "include",
                        text: this.$fn.pgettext("InvoiceGenerator", "Include"),
                    },
                    {
                        value: "exclude",
                        text: this.$fn.pgettext("InvoiceGenerator", "Exclude"),
                    },
                ],
                taskStatusDismissed: false,
                ux: null,
                b_5733683578645513_clearable: false,
            },
        };
    }
    get canAddFilter() {
        if (this.loaded) {
            return this.selectedFilterType && this.selectedFilterValue && this.selectedOperation;
        }
        return null;
    }
    get canSubmit() {
        if (this.loaded) {
            return this.forms.InvoiceGeneration &&
                this.forms.InvoiceGeneration.submittable &&
                (!this.currentGeneratorTask ||
                    ['PENDING', 'STARTED'].indexOf(this.currentGeneratorTask.status) == -1);
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_7344_getActionArgs($event) {
        return {
            path: "taskStatusDismissed",
            value: false,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_2248226175642056_setData_7346_getActionArgs($event) {
        return {
            path: "currentGeneratorTask",
            value: $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_2248226175642056_setData_7346_getWhen($event) {
        return !!$event.data;
    }
    async act_2248226175642056_crud_7342_getActionArgs($event) {
        return {
            objectType: "a_job",
            op: "upsert",
            data: { ...this.item, job_type: 'invoice_generation', ...this.getPayload() },
        };
    }
    async evh_2248226175642056_submit(event, scope) {
        return await this.actions.evh_2248226175642056_submit.executeFromDOM(this, event, scope);
    }
    async act_2646611882120999_script_7348_getActionArgs_value($event) {
        this.filters.push({
            id: this.selectedFilterValue.id,
            type: this.selectedFilterType.target,
            op: this.selectedOperation,
            value: this.selectedFilterValue
        });
        this.filters = this.filters.slice();
        this.selectedFilterValue = null;
    }
    async act_2646611882120999_script_7348_getActionArgs($event) {
        return {
            value: () => this.act_2646611882120999_script_7348_getActionArgs_value($event),
        };
    }
    async evh_2646611882120999_click(event, scope) {
        return await this.actions.evh_2646611882120999_click.executeFromDOM(this, event, scope);
    }
    async act_7132940374174171_script_7350_getActionArgs_value($event) {
        (_.remove(this.filters, p => p.id == $event.scope.filter.id && p.op === $event.scope.filter.op),
            this.filters = this.filters.slice());
    }
    async act_7132940374174171_script_7350_getActionArgs($event) {
        return {
            value: () => this.act_7132940374174171_script_7350_getActionArgs_value($event),
        };
    }
    async evh_7132940374174171_click(event, scope) {
        return await this.actions.evh_7132940374174171_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7340 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7339 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7340,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7339],
        });
        const act_2248226175642056_setData_7344 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7344_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_before_7343 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7344,
            event: "before",
            displayName: "setData",
        });
        const act_2248226175642056_setData_7346 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7346_getActionArgs,
            when: this.act_2248226175642056_setData_7346_getWhen,
            events: [],
        });
        const evh_2248226175642056_success_7345 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7346,
            event: "success",
            displayName: "setData",
        });
        const act_2248226175642056_crud_7342 = new core_1.actions.CRUDAction({
            actionArgs: this.act_2248226175642056_crud_7342_getActionArgs,
            displayName: "submit",
            events: [evh_2248226175642056_before_7343, evh_2248226175642056_success_7345],
        });
        const evh_2248226175642056_submit_7341 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_crud_7342,
            event: "submit",
            displayName: "submit",
        });
        const evh_2248226175642056_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_submit_7341],
        });
        const act_2646611882120999_script_7348 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2646611882120999_script_7348_getActionArgs,
            events: [],
        });
        const evh_2646611882120999_click_7347 = new core_1.actions.EventHandlerImpl({
            action: act_2646611882120999_script_7348,
            event: "click",
            displayName: "script",
        });
        const evh_2646611882120999_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2646611882120999_click_7347],
        });
        const act_7132940374174171_script_7350 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7132940374174171_script_7350_getActionArgs,
            events: [],
        });
        const evh_7132940374174171_click_7349 = new core_1.actions.EventHandlerImpl({
            action: act_7132940374174171_script_7350,
            event: "click",
            displayName: "script",
        });
        const evh_7132940374174171_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7132940374174171_click_7349],
        });
        return {
            act_7315092382398562_reloadComponentData_7340,
            evh_7315092382398562_reload_7339,
            evh_7315092382398562_reload,
            act_2248226175642056_setData_7344,
            evh_2248226175642056_before_7343,
            act_2248226175642056_setData_7346,
            evh_2248226175642056_success_7345,
            act_2248226175642056_crud_7342,
            evh_2248226175642056_submit_7341,
            evh_2248226175642056_submit,
            act_2646611882120999_script_7348,
            evh_2646611882120999_click_7347,
            evh_2646611882120999_click,
            act_7132940374174171_script_7350,
            evh_7132940374174171_click_7349,
            evh_7132940374174171_click,
            submit: act_2248226175642056_crud_7342,
        };
    }
};
UcInvoiceGeneratorControls = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceGeneratorControls);
exports.default = UcInvoiceGeneratorControls;
vue_property_decorator_1.Vue.component("UcInvoiceGeneratorControls", UcInvoiceGeneratorControls);
